(function () {
  'use strict';

  function bind(root) {
    if (!root || root.dataset.raazzSpBound === '1') return;
    root.dataset.raazzSpBound = '1';

    if (root.parentElement && root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var trigger = root.querySelector('.raazz-pdp-sp__trigger');
    var panel = root.querySelector('.raazz-pdp-sp__panel');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var isOpen = !root.classList.contains('is-open');
      root.classList.toggle('is-open', isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
  }

  function init() {
    document.querySelectorAll('.raazz-pdp-sp').forEach(bind);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.raazz-pdp-sp__trigger')) return;

    document.querySelectorAll('.raazz-pdp-sp.is-open').forEach(function (root) {
      if (!root.contains(event.target)) {
        root.classList.remove('is-open');
        var trigger = root.querySelector('.raazz-pdp-sp__trigger');
        var panel = root.querySelector('.raazz-pdp-sp__panel');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.setAttribute('aria-hidden', 'true');
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
